module.exports = __webpack_public_path__ + "static/img/xinSwiperNew.c7804e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImg/xinSwiperNew.jpg
// module id = L+69
// module chunks = 0